module.exports = __webpack_public_path__ + "img/1-white.fb40be58.svg";